import '../../App.point.css';
import React, { Component } from 'react';
import fn_set_footer from './StdtMenuCmp';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, AlertModal, udfLogOut } from '../../common/common';
import loader from '../../imgs/ajax-loader.gif';
import { Navbar, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';

class NoticeArticleCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      isLoggedIn: null,
      articleInfo: {},
    };
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.udfSelectArticle('Y');
      } else if (data !== null && data.userSe === 'USR') {
        this.props.history.push('/menuList');
      } else {
        this.props.history.push('/');
      }
    });

    // 로그아웃 버튼 바인딩
    document.getElementById("logoutBtn").addEventListener('click', () => { udfLogOut(this) });
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });
  }

  componentWillUpdate = () => {
    $('a[role="tab"]').addClass('col text-center pl-2 pr-2');
  }

  udfSelectArticle = () => {
    let that = this;
    udfInlineLoading();

    let setData = {
      isMobile: 'Y',
      bbsId: that.props.match.params.bbsId,
      nttId: that.props.match.params.nttId
    };

    $.ajax({
      url: url + '/slp/stdt/selectBoardArticle.do',
      type: 'GET',
      dataType: 'jsonp',
      data: setData,
      success: function (data) {
        if (!data.success)
          that.componentDidMount();
        else {
          if (data.list !== undefined && data.list !== null) {
            that.setState({
              isLoggedIn: true,
              articleInfo: data.list[0],
            });
          }
        }
        udfNoneLoading();
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  render() {
    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        {/* loading image */}
        <div className="wrap-loading">
          <img src={loader} alt="로딩 이미지" />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          학교공지
        </Navbar>

        <div className='container-fluid' style={{ marginTop: '4rem' }}>
          <Row className="pb-2 border-bottom">
            <Col>
              {this.state.articleInfo.nttSj}
              <div style={{ fontSize: '.9rem', color: 'gray', marginTop: '.5rem' }}>{this.state.articleInfo.frstRegisterPnttm}</div>
            </Col>
          </Row>
          <Row className="pt-4">
            <Col>
              <p dangerouslySetInnerHTML={{ __html: this.state.articleInfo.nttCn }}></p>
            </Col>
          </Row>
          {
            this.props.match.params.bbsId === 'BBSMSTR_000000000002' && this.state.articleInfo.password !== '' ?
              <Row className="pt-4 text-center">
                <Col>
                  <a className="btn btn-outline-secondary" href={this.state.articleInfo.password} target="_blank" rel="noopener noreferrer" title="새창">
                    자세히 보기 (상세 페이지로 이동)</a>
                </Col>
              </Row>
              : null
          }
        </div>

        {fn_set_footer('')}
      </>
    );
  }
}

export default NoticeArticleCmp;